import { ArrowBackIos } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactElement, useState } from 'react';
import TicketLinkImportRowTableFeature from 'src/app/components/features/ticket-link-imports/TicketLinkImportRowTableFeature';
import { useSpacingStyles } from 'src/shared/styles/spacingStyles';
import Button from 'src/view/components/button/Button';
import CheckboxWithLabel from 'src/view/components/checkbox-with-label/CheckboxWithLabel';

const useStyles = makeStyles(() => ({
    spaceBetweenContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}));

export interface TicketLinkImportDetailFeatureProps {
    eventId: string;
    importId: string;
    bookingOptionName: string;
    onBack: () => void;
}

export default function TicketLinkImportDetailFeature(
    props: Readonly<TicketLinkImportDetailFeatureProps>
): ReactElement {
    const [failedRowsOnly, setFailedRowsOnly] = useState<boolean>(false);

    const classes = useStyles();
    const spacingClasses = useSpacingStyles();

    return (
        <>
            <div className={spacingClasses.spacingBottom}>
                <div className={classes.spaceBetweenContainer}>
                    <Button
                        variant="text"
                        startIcon={<ArrowBackIos />}
                        onClick={props.onBack}
                    >
                        Back to list
                    </Button>
                    <CheckboxWithLabel
                        label="Failed rows only"
                        checked={failedRowsOnly}
                        onChange={() => setFailedRowsOnly(!failedRowsOnly)}
                    />
                </div>
            </div>

            <TicketLinkImportRowTableFeature
                eventId={props.eventId}
                ticketLinkImportId={props.importId}
                failedRowsOnly={failedRowsOnly}
                bookingOptionName={props.bookingOptionName}
            />
        </>
    );
}